module.exports = __webpack_public_path__ + "img/u_pen.ec1ecc8f.svg";